// extracted by mini-css-extract-plugin
export default {"changeLink":"YR-z","disabled":"ZR-z","inline":"_R-z"};